var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "800",
      "persistent": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v("Отправка заявления")]), _c('v-card-text', {
    staticClass: "border-top pb-0 pt-5",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-alert', {
    staticClass: "mb-0",
    attrs: {
      "outlined": "",
      "type": "info",
      "text": "",
      "rounded": "lg"
    }
  }, [_vm._v(" Прежде чем отправить заявление вам необходмо скачать печатную форму ")])], 1), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('FileInput', {
    attrs: {
      "title": "Файл документа заявления"
    },
    on: {
      "set-files": _vm.setFiles
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "success",
      "loading": _vm.printLoading
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('get-print');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-check-circle-outline")]), _vm._v(" Скачать заявление ")], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey"
    },
    on: {
      "click": _vm.closeConfirmModal
    }
  }, [_vm._v("Отмена")]), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.loading,
      "disabled": _vm.disabledBtn,
      "text": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" Отправить ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }